import { t } from "ttag";

import { Box, Card, Icon, Stack, Text, Title } from "metabase/ui";

/**
 * 99digital: shown instead of the admin panel when the current client's IP address is not on
 * METABASE_ADMIN_PANEL_ALLOWED_IPS.
 *
 * This is presentation only. The restriction itself is enforced on the server, in
 * `metabase.server.middleware.admin-ip-allowlist` (page loads) and in
 * `metabase.api.common/check-superuser` (every admin API), so a user cannot get around it by
 * navigating inside the SPA or by calling the API directly.
 */
export const AdminIpBlocked = (): JSX.Element => (
  <Box p="xl" data-testid="admin-ip-blocked">
    <Card maw="34rem" mx="auto" mt="xl" p="xl" withBorder>
      <Stack align="center" gap="md">
        <Icon name="lock" size={32} c="text-light" />
        <Title order={2} ta="center">{t`This page is blocked`}</Title>
        <Text ta="center" c="text-secondary">
          {t`The admin panel is restricted to approved IP addresses, and this address is not on the list.`}
        </Text>
        <Text ta="center" c="text-light" size="sm">
          {t`If you need access, ask an administrator to add your IP address to the allowlist.`}
        </Text>
      </Stack>
    </Card>
  </Box>
);
